const char_set = [
  {
    char: "A",
    name: "char_A",
    svg: ``,
    unicode: "\u0041",
  },
  {
    char: "B",
    name: "char_B",
    svg: ``,
    unicode: "\u0042",
  },
  {
    char: "C",
    name: "char_C",
    svg: ``,
    unicode: "\u0043",
  },
  {
    char: "D",
    name: "char_D",
    svg: ``,
    unicode: "\u0044",
  },
  {
    char: "E",
    name: "char_E",
    svg: ``,
    unicode: "\u0045",
  },
  {
    char: "F",
    name: "char_F",
    svg: ``,
    unicode: "\u0046",
  },
  {
    char: "G",
    name: "char_G",
    svg: ``,
    unicode: "\u0047",
  },
  {
    char: "H",
    name: "char_H",
    svg: ``,
    unicode: "\u0048",
  },
  {
    char: "I",
    name: "char_I",
    svg: ``,
    unicode: "\u0049",
  },
  {
    char: "J",
    name: "char_J",
    svg: ``,
    unicode: "\u004A",
  },
  {
    char: "K",
    name: "char_K",
    svg: ``,
    unicode: "\u004B",
  },
  {
    char: "L",
    name: "char_L",
    svg: ``,
    unicode: "\u004C",
  },
  {
    char: "M",
    name: "char_M",
    svg: ``,
    unicode: "\u004D",
  },
  {
    char: "N",
    name: "char_N",
    svg: ``,
    unicode: "\u004E",
  },
  {
    char: "O",
    name: "char_O",
    svg: ``,
    unicode: "\u004F",
  },
  {
    char: "P",
    name: "char_P",
    svg: ``,
    unicode: "\u0050",
  },
  {
    char: "Q",
    name: "char_Q",
    svg: ``,
    unicode: "\u0051",
  },
  {
    char: "R",
    name: "char_R",
    svg: ``,
    unicode: "\u0052",
  },
  {
    char: "S",
    name: "char_S",
    svg: ``,
    unicode: "\u0053",
  },
  {
    char: "T",
    name: "char_T",
    svg: ``,
    unicode: "\u0054",
  },
  {
    char: "U",
    name: "char_U",
    svg: ``,
    unicode: "\u0055",
  },
  {
    char: "V",
    name: "char_V",
    svg: ``,
    unicode: "\u0056",
  },
  {
    char: "W",
    name: "char_W",
    svg: ``,
    unicode: "\u0057",
  },
  {
    char: "X",
    name: "char_X",
    svg: ``,
    unicode: "\u0058",
  },
  {
    char: "Y",
    name: "char_Y",
    svg: ``,
    unicode: "\u0059",
  },
  {
    char: "Z",
    name: "char_Z",
    svg: ``,
    unicode: "\u005A",
  },
  {
    char: "a",
    name: "char_a",
    svg: ``,
    unicode: "\u0061",
  },
  {
    char: "b",
    name: "char_b",
    svg: ``,
    unicode: "\u0062",
  },
  {
    char: "c",
    name: "char_c",
    svg: ``,
    unicode: "\u0063",
  },
  {
    char: "d",
    name: "char_d",
    svg: ``,
    unicode: "\u0064",
  },
  {
    char: "e",
    name: "char_e",
    svg: ``,
    unicode: "\u0065",
  },
  {
    char: "f",
    name: "char_f",
    svg: ``,
    unicode: "\u0066",
  },
  {
    char: "g",
    name: "char_g",
    svg: ``,
    unicode: "\u0067",
  },
  {
    char: "h",
    name: "char_h",
    svg: ``,
    unicode: "\u0068",
  },
  {
    char: "i",
    name: "char_i",
    svg: ``,
    unicode: "\u0069",
  },
  {
    char: "j",
    name: "char_j",
    svg: ``,
    unicode: "\u006A",
  },
  {
    char: "k",
    name: "char_k",
    svg: ``,
    unicode: "\u006B",
  },
  {
    char: "l",
    name: "char_l",
    svg: ``,
    unicode: "\u006C",
  },
  {
    char: "m",
    name: "char_m",
    svg: ``,
    unicode: "\u006D",
  },
  {
    char: "n",
    name: "char_n",
    svg: ``,
    unicode: "\u006E",
  },
  {
    char: "o",
    name: "char_o",
    svg: ``,
    unicode: "\u006F",
  },
  {
    char: "p",
    name: "char_p",
    svg: ``,
    unicode: "\u0070",
  },
  {
    char: "q",
    name: "char_q",
    svg: ``,
    unicode: "\u0071",
  },
  {
    char: "r",
    name: "char_r",
    svg: ``,
    unicode: "\u0072",
  },
  {
    char: "s",
    name: "char_s",
    svg: ``,
    unicode: "\u0073",
  },
  {
    char: "t",
    name: "char_t",
    svg: ``,
    unicode: "\u0074",
  },
  {
    char: "u",
    name: "char_u",
    svg: ``,
    unicode: "\u0075",
  },
  {
    char: "v",
    name: "char_v",
    svg: ``,
    unicode: "\u0076",
  },
  {
    char: "w",
    name: "char_w",
    svg: ``,
    unicode: "\u0077",
  },
  {
    char: "x",
    name: "char_x",
    svg: ``,
    unicode: "\u0078",
  },
  {
    char: "y",
    name: "char_y",
    svg: ``,
    unicode: "\u0079",
  },
  {
    char: "z",
    name: "char_z",
    svg: ``,
    unicode: "\u007A",
  },
  {
    char: "0",
    name: "char_0",
    svg: ``,
    unicode: "\u0030",
  },
  {
    char: "1",
    name: "char_1",
    svg: ``,
    unicode: "\u0031",
  },
  {
    char: "2",
    name: "char_2",
    svg: ``,
    unicode: "\u0032",
  },
  {
    char: "3",
    name: "char_3",
    svg: ``,
    unicode: "\u0033",
  },
  {
    char: "4",
    name: "char_4",
    svg: ``,
    unicode: "\u0034",
  },
  {
    char: "5",
    name: "char_5",
    svg: ``,
    unicode: "\u0035",
  },
  {
    char: "6",
    name: "char_6",
    svg: ``,
    unicode: "\u0036",
  },
  {
    char: "7",
    name: "char_7",
    svg: ``,
    unicode: "\u0037",
  },
  {
    char: "8",
    name: "char_8",
    svg: ``,
    unicode: "\u0038",
  },
  {
    char: "9",
    name: "char_9",
    svg: ``,
    unicode: "\u0039",
  },
  {
    char: ".",
    name: "char_fullstop",
    svg: ``,
    unicode: "\u002E",
  },
  {
    char: ",",
    name: "char_comma",
    svg: ``,
    unicode: "\u002C",
  },
  {
    char: "?",
    name: "char_question_mark",
    svg: ``,
    unicode: "\u003F",
  },
  {
    char: "!",
    name: "char_exclamation_mark",
    svg: ``,
    unicode: "\u0021",
  },
  {
    char: '"',
    name: "char_double_quotes",
    svg: ``,
    unicode: "\u0022",
  },
  {
    char: "'",
    name: "char_single_quotes",
    svg: ``,
    unicode: "\u0027",
  },
  {
    char: "`",
    name: "char_back_ticks",
    svg: ``,
    unicode: "\u0060",
  },
  {
    char: "~",
    name: "char_tilde",
    svg: ``,
    unicode: "\u007E",
  },
  {
    char: "_",
    name: "char_under_score",
    svg: ``,
    unicode: "\u005F",
  },
  {
    char: ":",
    name: "char_colon",
    svg: ``,
    unicode: "\u003A",
  },
  {
    char: ";",
    name: "char_semi_colon",
    svg: ``,
    unicode: "\u003B",
  },
  {
    char: "-",
    name: "char_minus",
    svg: ``,
    unicode: "\u002D",
  },
  {
    char: "+",
    name: "char_plus",
    svg: ``,
    unicode: "\u002B",
  },
  {
    char: "=",
    name: "char_equals",
    svg: ``,
    unicode: "\u003D",
  },
  {
    char: "<",
    name: "char_less_than",
    svg: ``,
    unicode: "\u003C",
  },
  {
    char: ">",
    name: "char_greater_than",
    svg: ``,
    unicode: "\u003E",
  },
  {
    char: "(",
    name: "char_left_parenthesis",
    svg: ``,
    unicode: "\u0028",
  },
  {
    char: ")",
    name: "char_right_parenthesis",
    svg: ``,
    unicode: "\u0029",
  },
  {
    char: "[",
    name: "char_left_square_brackets",
    svg: ``,
    unicode: "\u005B",
  },
  {
    char: "]",
    name: "char_right_square_brackets",
    svg: ``,
    unicode: "\u005D",
  },
  {
    char: "{",
    name: "char_left_curly_brackets",
    svg: ``,
    unicode: "\u007B",
  },
  {
    char: "}",
    name: "char_right_curly_brackets",
    svg: ``,
    unicode: "\u007D",
  },
  {
    char: "\\",
    name: "char_F",
    name: "char_back_slash",
    svg: ``,
    unicode: "\u005C",
  },
  {
    char: "|",
    name: "char_vertical_bar",
    svg: ``,
    unicode: "\u007C",
  },
  {
    char: "/",
    name: "char_forward_slash",
    svg: ``,
    unicode: "\u002F",
  },
  {
    char: "#",
    name: "char_hash",
    svg: ``,
    unicode: "\u0023",
  },
  {
    char: "@",
    name: "char_at_mark",
    svg: ``,
    unicode: "\u0040",
  },
  {
    char: "$",
    name: "char_dollar",
    svg: ``,
    unicode: "\u0024",
  },
  {
    char: "%",
    name: "char_percent",
    svg: ``,
    unicode: "\u0025",
  },
  {
    char: "^",
    name: "char_caret",
    svg: ``,
    unicode: "\u005E",
  },
  {
    char: "&",
    name: "char_ampersand",
    svg: ``,
    unicode: "\u0026",
  },
  {
    char: "*",
    name: "char_asterik",
    svg: ``,
    unicode: "\u002A",
  },
  {
    char: "₹",
    name: "char_rupee",
    svg: ``,
    unicode: "\u20B9",
  },
];

const last_part = `</font>
  </defs>
  </svg>`;

export { char_set, last_part };
